import { h } from 'preact';

const Reel = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path class="st0" d="M14.5 14h-2.913C13.627 12.775 15 10.548 15 8c0-3.86-3.141-7-7-7-3.86 0-7 3.14-7 7 0 3.859 3.14 7 7 7h6.5a.5.5 0 0 0 0-1zM2 8c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6z" />
			<circle class="st0" cx="8" cy="5" r="1" />
			<circle class="st0" cx="5" cy="8" r="1" />
			<circle class="st0" cx="11" cy="8" r="1" />
			<circle class="st0" cx="8" cy="11" r="1" />
		</svg>
	);
};

export default Reel;
